import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import HintIcon from './HintIcon';

/** One key for every page that offers the filter, so ticking it on the Overview is still ticked on
 *  Prices & ABT. The pages are separate routes and never mounted together, so reading the stored value on
 *  mount is all "synced" needs — no shared context, and no re-render of the version selector on a click. */
const STORAGE_KEY = 'budgetHideInactive';

/**
 * CALL-778: the shared state behind the `Inaktive ausblenden` filter. Default ON — the client asked for
 * obsolete partners to be out of the way by default.
 */
export const useHideInactive = () => useLocalStorage<boolean>(STORAGE_KEY, true);

interface HideInactiveFilterProps {
    checked: boolean;
    onChange: (value: boolean) => void;
}

/**
 * The `Inaktive ausblenden` checkbox and its note.
 *
 * Extracted once the Overview and Prices & ABT both offered it (CALL-778): the two must not drift on the
 * label, the note, or the storage key behind them.
 */
const HideInactiveFilter = ({ checked, onChange }: HideInactiveFilterProps) => {
    const { t } = useTranslation('budget');

    return (
        <>
            <FormControlLabel
                sx={{ m: 0 }}
                control={
                    <Checkbox
                        size="small"
                        checked={checked}
                        onChange={(event) => onChange(event.target.checked)}
                        sx={{ py: 0 }}
                    />
                }
                label={
                    <Typography variant="body2">
                        <span>{t('filter.hideInactive')}</span>
                    </Typography>
                }
            />
            {/* "Inactive" reads like a deactivation, which this deliberately is not — the note says how far
                the filter reaches. */}
            <HintIcon notes={t('hint.hideInactiveVisualOnly')} />
        </>
    );
};

export default HideInactiveFilter;
